<template>
  <div ref="box" class="position-relative" style="z-index: 10">
    <v-row v-if="chat.cat==='queue' || chat.cat==='closed'" no-gutters>
      <v-col cols="12">
        <v-divider/>
      </v-col>
      <v-col cols="12">
        <v-btn
            :loading="joinChatState.loading"
            block
            depressed height="47" small
            style="border-radius: 0"
            @click="joinChat"
        >
          Присоединиться
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else-if="chat.dialogUsers?.some(v => v.user?.id === $store.state.user?.id)" no-gutters>
      <v-col cols="12">
        <v-divider/>
      </v-col>
      <v-col>
        <div id="helps" class="position-relative"></div>
        <v-menu ref="helps" v-model="helpsOpen" attach="#helps" max-height="400" top>
          <v-list class="pa-0" dense>
            <v-list-item
                v-for="(item, i) in helps"
                :key="i"
                class="pa-0"
                @click="selectHelp(item)"
            >
              <div class="full-width">
                <div class="py-2 px-4">
                  <div class="body-2" v-html="$tools.nl2br($tools.textHighlight(item.text, messText))"></div>
                </div>
                <v-divider/>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-textarea
            ref="messText"
            v-model="messText"
            auto-grow flat hide-details rows="1" solo
            placeholder="Введите сообщения..."
            @keyup="templateId = null"
            @keydown.enter.exact.prevent="messageSend"
            @keydown.enter.ctrl.prevent="messText+='\n'"
        >
        </v-textarea>
      </v-col>
      <v-col v-if="!$tools.isEmpty(messText)" class="pt-1 pr-2" cols="auto">
        <v-btn icon @click="messText=null;templateId=null">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col class="pt-1 pr-2" cols="auto">
        <v-btn icon @click="attach=true;attachUrls=[]">
          <v-icon>mdi-paperclip</v-icon>
        </v-btn>
        <uploader
            :dialog.sync="attach"
            :multiple="true"
            url="/napi/file/"
            @uploadComplete="(v)=>{
              if(v.length===0) return null;
              attachUrls=v;
              messageSend();
            }"
            sendActionName="Отправить"
        />
      </v-col>
      <v-col class="pt-1 pr-1" cols="auto">
        <v-btn :loading="messageSendState.loadingUpdate" icon @click="messageSend">
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Uploader from "../../../../components/Uploader.vue";
import Stater from "../../../../plugins/stater";
import axios from "axios";

export default {
  components: {Uploader},
  props: ['chat', 'messageTemplates'],
  data: () => ({
    joinChatState: new Stater(),

    provider: null,
    messText: null,
    templateId: null,
    attach: false,
    attachUrls: [],
    messageSendState: new Stater(),
    helps: [],
    helpsOpen: false,

  }),
  mounted() {
    this.heightUpdate();
    this.helpsCompute();
  },
  watch: {
    chat() {
      this.heightUpdate();
    },
    messText() {
      this.heightUpdate();
      this.helpsCompute();
    },
    messageTemplates() {
      this.helpsCompute();
    },
  },
  methods: {
    heightUpdate() {
      this.$emit('heightUpdate', this.$refs.box.offsetHeight);
      setTimeout(() => this.$emit('heightUpdate', this.$refs.box.offsetHeight), 250)
    },
    joinChat() {
      this.joinChatState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chat.id + '/join/', {
        onlyMeAsInternal:true
      }).then(() => {
        this.joinChatState.stateSuccess();
      }).catch(() => {
        this.joinChatState.stateError();
      });
    },
    messageSend() {
      if (this.messageSendState.loadingUpdate)
        return;
      if (this.$tools.isEmpty(this.messText) && this.attachUrls.length === 0)
        return;

      this.messageSendState.stateLoadingUpdate()
      axios.post('/napi/dialog/chat/' + this.chat.id + '/message/', {
        text: this.messText,
        attachUrls: this.attachUrls,
      }).then(() => {
        this.messText = '';
        this.templateId = null;
        this.attachUrls = [];
        this.$emit('scrollBottom');
        this.messageSendState.stateSuccess()
      }).catch(() => {
        this.messText = '';
        this.templateId = null;
        this.attachUrls = [];
        this.$emit('scrollBottom');
        this.messageSendState.stateSuccess()
      });
    },
    messageTemplateSelect(v) {
      if (!this.$tools.isDefined(v))
        return;
      this.messText = v.textResult || v.text;
      this.templateId = v.id;
    },
    selectHelp(item) {
      this.messageTemplateSelect({
        id: item.id,
        text: item.text,
        textResult: item.text,
      });
    },
    helpsCompute() {
      if (this.$tools.isBlank(this.messText)) {
        this.helps = [];
        this.helpsOpen = false;
      } else {
        let templates = this.messageTemplates || [];
        this.helps = templates.filter(v => v.text.toLowerCase().includes(this.messText.toLowerCase()))
        if (this.helps.length === 1 && this.helps[0].text === this.messText)
          this.helpsOpen = false;
        else
          this.helpsOpen = true;
      }
      if (this.$tools.isDefined(this.$refs.helps))
        this.$refs.helps.updateDimensions();
    },

  }
}
</script>